import React from 'react';
import '../fichierCss/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer text-white">
      <div className="container py-4">
        <div className="row g-4 align-items-center">
          <div className="col-12 col-md-6">
            <h5 className="mb-2">APSAM</h5>
            <p className="mb-0 footer-text">
              Association engagée pour la solidarité, la culture et l’entraide.
            </p>
          </div>

          <div className="col-12 col-md-6 text-md-end">
            <div className="d-flex gap-2 justify-content-md-end justify-content-start">
              <a className="social-btn" href="#!" aria-label="Facebook"><i className="fab fa-facebook-f" /></a>
              <a className="social-btn" href="#!" aria-label="Twitter"><i className="fab fa-twitter" /></a>
              <a className="social-btn" href="#!" aria-label="Instagram"><i className="fab fa-instagram" /></a>
              <a className="social-btn" href="#!" aria-label="LinkedIn"><i className="fab fa-linkedin-in" /></a>
              <a className="social-btn" href="#!" aria-label="GitHub"><i className="fab fa-github" /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom text-center py-3">
        © {currentYear} APSAM — Tous droits réservés
      </div>
    </footer>
  );
};

export default Footer;